export default "__VITE_ASSET__44a4bb9e__"